var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "activity-stage"
  }, [_c('div', {
    staticClass: "left-right-panel-reveal-container block-container"
  }, _vm._l(_vm.blocks, function (block, i) {
    return _c('div', {
      key: i,
      staticClass: "block",
      attrs: {
        "id": [("block-" + i)],
        "track-by": i
      }
    }, _vm._l(block.paragraphs, function (paragraph, j) {
      return _c('div', {
        key: j,
        staticClass: "block-paragraph",
        attrs: {
          "track-by": j
        }
      }, [_c('blinking-cursor-text', {
        attrs: {
          "text": paragraph.text,
          "text-step": paragraph.matchingStepIndex
        }
      })], 1);
    }), 0);
  }), 0), _c('div', {
    attrs: {
      "id": "img-overlay"
    }
  }, [_c('div', {
    attrs: {
      "id": "img-background"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.image
    }
  })])]), _c('div', {
    attrs: {
      "id": "end-instructions"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.endInstructions) + "\n  ")]), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }